import { Endpoint, RecordsForPage } from "../mb_constants";

/**
 * 
 * @param {*} page 
 * @param {*} search 
 * @returns 
 */
const MbApi_ListPriceList = async (page, search, getAll = null) => {
    
    try{
        const response = await fetch(
            `${Endpoint}/api/mb/v1/list_price/list?page=${page}&record_for_page=${!getAll ? RecordsForPage : "99999"}${search ? `&search=${search}` : ''}`,
            {
                headers: {
                    'jwt': `Bearer ${localStorage.getItem('jwt')}`
                }
            }
        );

        if(response.status == 200){
            const data = await response.json();
            return data;
        }
    }catch(_){
        
    }

    return null;
};

/**
 * 
 * @param {*} body 
 * @returns 
 */
const MbApi_ListPriceCreate = async (body) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/list_price/create`,
        {
            method: "POST",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            },
            body: body
        }
    );

    try{
        if(response.status == 201){
            const res = await response.json();
            if(res.Result == "OK"){
                return res.Json;
            }
        }
    }catch(_){

    }

    return false;
};

/**
 * 
 * @param {*} id_list_price
 * @returns 
 */
const MbApi_ListPriceDelete = async (id_list_price) => {

    const response = await fetch(
        `${Endpoint}/api/mb/v1/list_price/delete?id_list_price=${id_list_price}`,
        {
            method: "DELETE",
            headers: {
                'jwt': `Bearer ${localStorage.getItem('jwt')}`,
                'Content-Type': "application/json"
            }
        }
    );

    try{
        if(response.status == 200){
            const res = await response.json();
            if(res.Result == "OK"){
                return true;
            }
        }
    }catch(_){

    }

    return false;

};

export {
    MbApi_ListPriceList,
    MbApi_ListPriceCreate,
    MbApi_ListPriceDelete
}